import React from "react";
import { Box } from "@mui/material";
import { rf } from "../theme";

// A live class, drawn in the page's own language: flat fills, black outlines,
// no gradients or soft shadows. The window chrome is the reference site's
// device-mockup idea, reduced to shapes we can actually draw ourselves.
const Person = ({ x, y, skin, shirt, hair }) => (
  <g transform={`translate(${x} ${y})`}>
    <circle cx="0" cy="-4" r="9" fill={skin} stroke={rf.ink} strokeWidth="2.4" />
    <path d="M-9 -6a9 9 0 0 1 18 0z" fill={hair} stroke={rf.ink} strokeWidth="2.4" strokeLinejoin="round" />
    <path d="M-13 20a13 13 0 0 1 26 0z" fill={shirt} stroke={rf.ink} strokeWidth="2.4" strokeLinejoin="round" />
  </g>
);

const Tile = ({ x, y, w = 92, h = 74, fill, children, label }) => (
  <g transform={`translate(${x} ${y})`}>
    <rect width={w} height={h} rx="10" fill={fill} stroke={rf.ink} strokeWidth="2.6" />
    {children}
    {label && (
      <g>
        <rect x="7" y={h - 20} width="34" height="13" rx="6.5" fill={rf.paper} stroke={rf.ink} strokeWidth="2" />
      </g>
    )}
  </g>
);

export const ClassroomScene = ({ className }) => (
  <Box className={className} sx={{ width: "100%", maxWidth: 480, mx: "auto" }}>
    <Box
      component="svg"
      viewBox="0 0 360 320"
      sx={{ width: "100%", height: "auto", display: "block", filter: "none" }}
      role="img"
      aria-label="A live class window with four learners and an instructor sharing a screen"
    >
      {/* Window */}
      <rect x="10" y="22" width="340" height="272" rx="18" fill={rf.paper} stroke={rf.ink} strokeWidth="3" />
      <rect x="10" y="22" width="340" height="34" rx="18" fill={rf.creamDeep} stroke={rf.ink} strokeWidth="3" />
      <rect x="10" y="46" width="340" height="10" fill={rf.creamDeep} />
      <line x1="10" y1="56" x2="350" y2="56" stroke={rf.ink} strokeWidth="3" />
      <circle cx="32" cy="39" r="5" fill={rf.coral} stroke={rf.ink} strokeWidth="2" />
      <circle cx="50" cy="39" r="5" fill={rf.amber} stroke={rf.ink} strokeWidth="2" />
      <circle cx="68" cy="39" r="5" fill={rf.mint} stroke={rf.ink} strokeWidth="2" />

      {/* LIVE badge */}
      <g>
        <rect x="270" y="30" width="62" height="20" rx="10" fill={rf.coral} stroke={rf.ink} strokeWidth="2.4" />
        <circle cx="283" cy="40" r="4" fill={rf.paper} stroke={rf.ink} strokeWidth="1.8" />
        <text x="293" y="44" fontFamily="'Outfit', sans-serif" fontSize="11" fontWeight="800" fill={rf.ink}>
          LIVE
        </text>
      </g>

      {/* Instructor's shared board */}
      <g transform="translate(26 70)">
        <rect width="200" height="126" rx="12" fill={rf.sky} stroke={rf.ink} strokeWidth="2.8" />
        <rect x="16" y="18" width="120" height="10" rx="5" fill={rf.paper} stroke={rf.ink} strokeWidth="2" />
        <rect x="16" y="40" width="168" height="10" rx="5" fill={rf.paper} stroke={rf.ink} strokeWidth="2" />
        <rect x="16" y="62" width="92" height="10" rx="5" fill={rf.paper} stroke={rf.ink} strokeWidth="2" />
        {/* a rising line, drawn the way the logo rises */}
        <path d="M18 106 L62 92 L104 98 L150 72 L184 80" fill="none" stroke={rf.ink} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="150" cy="72" r="6" fill={rf.amber} stroke={rf.ink} strokeWidth="2.4" />
      </g>

      {/* Instructor tile */}
      <Tile x={238} y={70} w={92} h={126} fill={rf.amber}>
        <Person x={46} y={52} skin="#E8B98C" shirt={rf.paper} hair="#3B2B20" />
        <rect x="14" y="98" width="64" height="14" rx="7" fill={rf.paper} stroke={rf.ink} strokeWidth="2" />
      </Tile>

      {/* The batch */}
      <Tile x={26} y={208} w={92} h={74} fill={rf.creamDeep} label>
        <Person x={46} y={30} skin="#C98D63" shirt={rf.coral} hair="#1F1B18" />
      </Tile>
      <Tile x={132} y={208} w={92} h={74} fill={rf.creamDeep} label>
        <Person x={46} y={30} skin="#F0C9A4" shirt={rf.mint} hair="#7A4A24" />
      </Tile>
      <Tile x={238} y={208} w={92} h={74} fill={rf.creamDeep} label>
        <Person x={46} y={30} skin="#8D5A3B" shirt={rf.lilac} hair="#161311" />
      </Tile>
    </Box>
  </Box>
);

export default ClassroomScene;
